import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { ImageEditPageComponent } from "@features/image/pages/edit/image-edit-page.component";
import { SubjectTypeSuggestionState } from "@features/image/services/subject-type-suggestion.interface";
import { SubjectTypeSuggestionService } from "@features/image/services/subject-type-suggestion.service";
import { FieldWrapper } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "astrobin-subject-type-with-suggestion",
  templateUrl: "./subject-type-with-suggestion.component.html",
  styleUrls: ["./subject-type-with-suggestion.component.scss"]
})
export class SubjectTypeWithSuggestionComponent extends FieldWrapper implements OnInit, OnDestroy {
  private readonly destroyed$ = new Subject<void>();
  suggestionState: SubjectTypeSuggestionState;

  constructor(
    public readonly imageEditPageComponent: ImageEditPageComponent,
    private readonly subjectTypeSuggestionService: SubjectTypeSuggestionService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    // Check if polling is active when component initializes
    if (this.subjectTypeSuggestionService.isPolling) {
      // Set to polling state immediately if polling is active
      this.suggestionState = {
        status: "polling",
        suggestion: null,
        error: null,
        appliedSuggestion: false,
        dismissed: false
      };
      // Force change detection
      this.changeDetectorRef.detectChanges();
    }

    // Subscribe to the state changes
    this.subjectTypeSuggestionService.subjectTypeSuggestionState$.pipe(takeUntil(this.destroyed$)).subscribe(state => {
      this.suggestionState = state;
      // Manually trigger change detection when state updates
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get showSuggestion(): boolean {
    return (
      !!this.suggestionState &&
      !this.suggestionState.dismissed &&
      !this.formControl.value &&
      (this.suggestionState.status === "polling" ||
        (this.suggestionState.status === "completed" &&
          !!this.suggestionState.suggestion &&
          this.suggestionState.suggestion.confidence >= 0.85 &&
          !this.suggestionState.appliedSuggestion)) // Show suggestions 85%+ that weren't auto-applied
    );
  }

  get showAutoAppliedInfo(): boolean {
    return (
      !!this.suggestionState &&
      this.suggestionState.status === "completed" &&
      this.suggestionState.appliedSuggestion &&
      !this.suggestionState.dismissed &&
      !!this.formControl.value
    );
  }
}
